import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ControlledDatePicker } from '../../../../../shared';

const StartDateSection = () => {
  const { control } = useFormContext();
  const { t } = useTranslation('common', {
    keyPrefix: 'adminPortal.procedures.reports'
  });

  return (
    <ControlledDatePicker
      fullWidth
      variant="outlined"
      control={control}
      name="valid_from"
      label={t('validFrom')}
    />
  );
};

export default StartDateSection;
